<template>
  <div
    v-if="isLoading"
    class="mask"
  >
    <b-spinner
      :variant="variant"
      label="Spinning"
    />
  </div>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
};
</script>

<style scoped>
.mask {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1060;
  position: fixed;
  top: 0;
  left: 0;
}
</style>
